import createYearTabsListingView from '../PeriodTabs/createYearTabsListingView';
import FlexThesisCard from './FlexThesisCard';

// Theses key off `effective`, which for every completed thesis here is its
// submission date - the two agree on all 95. On a site that uses the type
// for open topics rather than finished work, as hrl-site does, there is no
// submission date and `effective` is simply when the topic was put up.
export default createYearTabsListingView(FlexThesisCard, {
  displayName: 'ThesisYearTabsView',
});
